export default __webpack_public_path__ + "img/cb82c249673c61612802d520316dbc59.png";